import { Dialog } from "construct-ui";
import loginModel from "../../../models/login.model";
import ExcelMultiChannels from "../../../models/registration/multi-channels/excel-multi-channels.model";
import userModel from "../../../models/user/user.model";
import ViewBase from "../../view-base.view";
import SMEDealerPrivacyPolicyView from "../privacy-policy/sme-incentive-dealer.view";
import SMEPrivacyPolicyRAView from "../privacy-policy/sme-incentive-ra.view";
import moment from "moment";
import { formats } from "../../../config/constants";

/**
 * Registration Excel - Multi Channels View
 *
 * @author cmc.nttruong1
 */
export default function RegistrationMultiChannels() {
  ViewBase.call(this);

  let MALAYSIA_CODE = 'MY';
  let backDateLimitDate = '';
  let excelRejectedRecords = [];
  let acceptPolicy = false;
  let isLegalClauseDialogOpen = false;
  let consentInfo = null;
  let isMalaysia = loginModel.credentials.country === MALAYSIA_CODE;

  let countTotalRecordsInserted = 0;
  let countTotalRecordsRejected = 0;
  let rejectedFileGUID = 0;
  let successFileGUID = 0;

  let errorMessage = '';

  const ACCEPTED_FILE_FORMAT = ['.xls', '.xlsx'];
  const FORM_ID = 'registrationExcelMultiChannelsUploadForm';
  const UPLOAD_INPUT_ID = 'registrationExcelMultiChannelsUploadInput';
  const BOOTSTRAP_INVALID_CLASS = 'is-invalid';
  const ROLES_TYPE = {
    DEALER: "DEALER",
    RA: "RA",
    NONE: "NONE"
  }

  const isDealerOrRA = () => consentInfo?.userType?.toLowerCase() !== ROLES_TYPE.NONE.toLowerCase();
  const isValidToRenderPrivacyPopup = () => isMalaysia && isDealerOrRA;
  const isDealer = () => consentInfo?.userType?.toLowerCase() === ROLES_TYPE.DEALER.toLowerCase();
  const isRA = () => consentInfo?.userType?.toLowerCase() === ROLES_TYPE.RA.toLowerCase();

  const validate = () => {
    // Form validation
    if (!this.validateForm()) {
      errorMessage = this.getText('EM00000316', 'Please select a file');
      return false;
    }

    let fileUploadInput = document.querySelector(`#${UPLOAD_INPUT_ID}`);
    if (!ACCEPTED_FILE_FORMAT.some(format => fileUploadInput.files[0].name.endsWith(format))) {
      fileUploadInput.classList.add(BOOTSTRAP_INVALID_CLASS);
      errorMessage = this.getText('EM00000058', 'Invalid file.');
      return false;
    }

    // in the event where previously was incorrect and it's been corrected, remove the invalid class
    fileUploadInput.classList.remove(BOOTSTRAP_INVALID_CLASS);
    return true;
  };

  const upload = (e) => {
    this.showLoading();

    let file = document.querySelector(`#${UPLOAD_INPUT_ID}`).files[0];
    ExcelMultiChannels.uploadExcel(file)
      .then((result) => {
        excelRejectedRecords = result.failRecords;
        countTotalRecordsInserted = result.totalInsertedRecord;
        countTotalRecordsRejected = result.totalFailRecord;

        successFileGUID = result.successFileGUID;
        rejectedFileGUID = result.rejectedFileGUID;

        isLegalClauseDialogOpen = false;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const handleUploadButtonClick = (e) => {
    e.preventDefault();
    if (!validate()) {
      e.stopPropagation();
      return;
    }

    if (loginModel.credentials.country === 'MY') {
      ExcelMultiChannels.getConsentInfo()
        .then((consentRes) => {
          consentInfo = consentRes;
          const isUserTypeNone = consentRes?.userType?.toLowerCase() === ROLES_TYPE.NONE.toLowerCase();
          if (isUserTypeNone) {
            upload();
          } else {
            isLegalClauseDialogOpen = true;
          }
        })
        .catch((error) => { this.handleError(error); })
        .finally(() => { this.hideLoading(); })
    } else {
      upload();
    }
  }

  const handleConfirmPolicyClick = () => {
    if (!acceptPolicy) {
      return;
    }
    upload();
  }

  const handleChangeAccept = (e) => {
    acceptPolicy = e.target.checked;
  }

  const onLegalClauseClose = () => {
    isLegalClauseDialogOpen = false;
  }

  const downloadExcelTemplate = () => {
    this.showLoading();

    ExcelMultiChannels.downloadExcelTemplate()
      .catch((error) => { this.handleError(error); })
      .finally(() => { this.hideLoading(); });
  };

  const downloadAttachments = (fileId, fileName) => {
    this.showLoading();
    ExcelMultiChannels.downloadFileResult(fileId, fileName)
      .catch((error) => { this.handleError(error) })
      .finally(() => { this.hideLoading(); })
  };


  const getBackDateLimitDate = () => {
    userModel
      .getBackDateLimitDate()
      .then((result) => {
        backDateLimitDate = result.date;
      })
      .catch((error) => { this.handleError(error); });
  };
  return {
    oninit: () => {
      getBackDateLimitDate()
    },
    view: () => {
      return [
        /* CARD */
        m(".card",
          m(".card-body",
            m(".row",
              m(".col-12",
                {
                  class:
                    loginModel.credentials.country === MALAYSIA_CODE ? '' : 'd-none'
                },
                m("h6.text-danger",
                  this.getText(
                    "",
                    "* For HHP products, end consume phone number is required to pay for incentive. Samsung terms and conditions apply. You can upload max 300 lines at one time."
                  )
                )
              ),
              m(".col-12",
                m("h5", [
                  m("strong",
                    this.getText("LT00000917", "Cannot register Sales Date before")
                  ),
                  ' ',
                  backDateLimitDate && m("strong.text-danger",
                    moment(backDateLimitDate).format(formats.dateFormat)
                  )
                ])
              ),
              m(".col-12.mb-3",
                m(".d-flex.justify-content-start.align-items-center",
                  m("h5.mb-0.me-4", { for: FORM_ID }, m("strong", this.getText("LT00000493", "Excel:"))),
                  m("form.position-relative.needs-validation[novalidate].me-3",
                    {
                      id: FORM_ID,
                      onsubmit: handleUploadButtonClick
                    },
                    m("input.form-control", {
                      id: UPLOAD_INPUT_ID,
                      type: "file",
                      accept: ACCEPTED_FILE_FORMAT.toString(),
                      required: true,
                    }),
                    m(".invalid-tooltip", errorMessage)
                  ),
                  m('button.btn.btn-primary[type="submit"].me-5',
                    {
                      form: FORM_ID,
                    },
                    m("i.bi.bi-file-earmark-arrow-up-fill"),
                    this.getText("LT00000290", "Upload")
                  ),
                  m("button.btn.btn-primary",
                    {
                      onclick: downloadExcelTemplate,
                    },
                    m("i.bi.bi-file-earmark-arrow-down-fill"),
                    this.getText("LT00000220", "Excel Template")
                  )
                )
              ),
              m(".col-12.mb-3",
                m(".d-flex.justify-content-start.align-items-center",
                  m("h5.mb-0.me-4",
                    m("strong.me-2", this.getText("LT00000794", "Total Record(s) Inserted: ")),
                    m("strong", countTotalRecordsInserted)
                  ),
                  countTotalRecordsInserted > 0 &&
                  m("h5.mb-0.me-4",
                    m("a",
                      { "href": "javascript:;", onclick: () => downloadAttachments(successFileGUID, "Download_Succeed_Records") },
                      m("strong.me-2", this.getText("LT00000911", "Download inserted record(s)")),
                    ),
                  ),
                )
              ),
              m(".col-12.mb-3",
                m(".d-flex.justify-content-start.align-items-center",
                  m("h5.mb-0.me-4",
                    m("strong.me-2", this.getText("LT00000795", "Total Record(s) Rejected: ")),
                    m("strong.text-danger", countTotalRecordsRejected)
                  ),
                  countTotalRecordsRejected > 0 &&
                  m("h5.mb-0.me-4",
                    m("a",
                      { "href": "javascript:;", onclick: () => downloadAttachments(rejectedFileGUID, "Download_Rejected_Records") },
                      m("strong.me-2", this.getText("LT00000912", "Download rejected record(s)")),
                    ),
                  )
                )
              ),
              m(".col-12",
                m(".table-responsive",
                  m("table.table.table-hover.sticky-column-start",
                    m("thead",
                      m("tr.align-middle",
                        m("th", this.getText("LT00000918", "Sales Date")),
                        m("th", this.getText("LT00000809", "Site ID")),
                        m("th", this.getText("LT00000908", "IMEI")),
                        m("th", this.getText("LT00000717", "Model")),
                        m("th", this.getText("LT00000909", "End User Name")),
                        m("th", this.getText("LT00000910", "End User Phone")),
                        m("th", this.getText("LT00000015", "Status"))
                      )
                    ),
                    m("tbody",
                      excelRejectedRecords.map((data, index) =>
                        m(`tr.align-middle${data.editableYN ? ".cursor-pointer" : ""}`,
                          data.editableYN && {
                            onclick: (event) => {
                              // Triggers select only when user click on the cell
                              if (event.target.localName === "td") {
                                document
                                  .querySelector(`#${CHECKBOX_NAME}${index}`)
                                  .dispatchEvent(new MouseEvent("click"));
                              }
                            },
                          },
                          m("td", m("span.cursor-text", data.saleDate)),
                          m("td", m("span.cursor-text", data.siteId)),
                          m("td", m("span.cursor-text", data.imei)),
                          m("td", m("span.cursor-text", data.modelCd)),
                          m("td", m("span.cursor-text", data.userName)),
                          m("td", m("span.cursor-text", data.userPhone)),
                          m("td", m("span.cursor-text", data.status)),
                        )
                      )
                    )
                  )
                )
              ),
            )
          )
        ),

        isValidToRenderPrivacyPopup() &&
        m(Dialog, {
          isOpen: isLegalClauseDialogOpen,
          onClose: () => {
            isLegalClauseDialogOpen = false;
            acceptPolicy = false;
          },
          title: this.getText('LT00000913', 'SME Legal Clause'),
          class: 'cui-dialog-xl',
          content: [
            isDealer() &&
            m(SMEDealerPrivacyPolicyView, {
              onChangeAccept: handleChangeAccept,
            }),
            isRA() &&
            m(SMEPrivacyPolicyRAView, {
              onChangeAccept: handleChangeAccept,
            }),
            this.getBaseViews(),
          ],
          footer: m('.d-flex.justify-content-end.gap-2',
            m('button.btn.btn-primary', { onclick: handleConfirmPolicyClick }, this.getText('LT00000043', 'Confirm')),
            m('button.btn.btn-white', { onclick: onLegalClauseClose }, this.getText('LT00000021', 'Close')),
          )
        }),

        this.getBaseViews(),
      ];
    },
  };
}
